import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter4() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          Once every few weeks, volunteers would hike up to 13 hours to collect the SD cards from
          the cameras. Then they would wait weeks to send hard drives via plane or barge to a data
          center in Santiago, Chile, where the photos were analyzed.
        </p>
        <p className="chapter__paragraph">
          “It's not so much the problem of ‘Is there a needle in a haystack?’ as the problem ‘Is
          there no needle in the haystack?’” Will says. Missing a few invasive animals will almost
          inevitably lead to the species reestablishing themselves, sometimes in just a matter of
          months.
        </p>
        <p className="chapter__paragraph">
          But by the time Island Conservation staff could sort through and refine the results,
          months would pass, rendering the data virtually obsolete and making it impossible to act
          in real-time—giving invasive rats and coatis the chance to repopulate.
        </p>
      </section>
      <PullQuote
        quote={
          "“I didn't know that you could bring the power of a data center to a particular edge location,” Will says."
        }
      />
      <section className="chapter">
        <p className="chapter__paragraph">
          But that changed when he met Charles Ferland, the Vice President and General Manager of
          Edge Computing at Lenovo.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
